import { render, staticRenderFns } from "./CalonAnggota.vue?vue&type=template&id=ad6c931e"
import script from "./CalonAnggota.vue?vue&type=script&lang=js"
export * from "./CalonAnggota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports